import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Opportunities } from "./constants";

const OpportunitySummaryChart = ({ dataSource }) => {
  const [data, setData] = useState({
    categories: [],
    chartData: [],
  });

  useEffect(() => {
    if (dataSource) {
      const opp_summary = dataSource;
      const categoriesKeys = Object.keys(opp_summary);
      const categories = categoriesKeys.map((key) => Opportunities[key]);
      const chartData = Object.values(opp_summary);
      setData({ categories, chartData });
    }
  }, [dataSource]);

  const chartOptions = {
    chart: {
      type: "column", // Vertical bar chart
    },
    title: {
      text: "Opportunity Summary",
    },
    xAxis: {
      categories: data.categories, // Corresponding to total_opportunities, realized_opportunities, unrealized_opportunities, archived_opportunities
      title: {
        text: "",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valueSuffix: " opportunities",
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Opportunities",
        data: data.chartData, // Corresponding to total_opportunities, realized_opportunities, unrealized_opportunities, archived_opportunities
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default OpportunitySummaryChart;
